export default class MessageDuplicateManager {
  constructor() {
    this._messageIds = {};
    this.wasMessageIdRecieved = (id, messageChannel) => {
      if (this._messageIds[id]) return true;
      this._messageIds[id] = messageChannel;
      setTimeout(() => {
        delete this._messageIds[id];
      }, 10000);
      return false;
    };
  }
}